import React from 'react';

const CleanUp = () => {
    return (
        <div>
            Clean up
        </div>
    );
};

export default CleanUp;